import { Store } from '@ngrx/store';
import { StoreState } from '..';
import { Observable } from 'rxjs';
import { State } from './reducer';
import { filter } from 'rxjs/operators';

export function getCurrentUserData(store: Store<StoreState>): Observable<State> {
  return store.select('login').pipe(
    filter(({ mdmid }) => mdmid !== ''),
  );
}
